import { useForm, Link, usePage, Head } from '@inertiajs/react'
import Logo from '@/components/Logo'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { FormEvent, ReactNode } from 'react'

export default function OrganizationPasswordResetNew() {
  const { flash } = usePage<{ flash: { success?: string; alert?: string } }>().props
  const { data, setData, post, processing } = useForm({
    email: '',
  })

  function submit(e: FormEvent) {
    e.preventDefault()
    post('/organizations/password_resets')
  }

  return (
    <>
      <Head title="Reset Organization Password" />
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-accent/10 to-primary/5 px-4">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex justify-center">
            <Logo />
          </div>
          <Card>
            <CardHeader className="text-center">
              <CardTitle className="text-3xl font-semibold">Reset your password</CardTitle>
              <CardDescription>Enter your organization email and we'll send you a reset link</CardDescription>
            </CardHeader>
            <CardContent>
              {flash.success && (
                <p className="mb-4 rounded-md bg-green-50 p-3 text-base text-green-800 dark:bg-green-950 dark:text-green-200">
                  {flash.success}
                </p>
              )}
              {flash.alert && (
                <p className="mb-4 rounded-md bg-red-50 p-3 text-base text-red-800 dark:bg-red-950 dark:text-red-200">
                  {flash.alert}
                </p>
              )}
              <form onSubmit={submit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={data.email}
                    onChange={e => setData('email', e.target.value)}
                    autoComplete="email"
                    autoFocus
                  />
                </div>

                <Button type="submit" className="w-full" disabled={processing}>
                  Send Reset Link
                </Button>
              </form>
            </CardContent>
            <CardFooter className="flex flex-col gap-2 text-center text-base">
              <p>
                <Link href="/organizations/sign_in" className="underline underline-offset-4 hover:text-primary">
                  Back to sign in
                </Link>
              </p>
            </CardFooter>
          </Card>
        </div>
      </div>
    </>
  )
}

OrganizationPasswordResetNew.layout = (page: ReactNode) => page
